/* Not loaded on the storefront: the theme loads predictive-search.min.js, a copy of this file. Shopify re-minifies .js assets into syntax iOS 13.0-13.3 cannot run, and serves .min.js files as they are. Make changes in predictive-search.min.js. */
(() => {
  // app/scripts/predictive-search.js
  var {
    serializeForm,
    debounceTime
  } = theme;
  var PredictiveSearch = class extends HTMLElement {
    connectedCallback() {
      var _this$events, _this$providerObserve;
      this.form = this.querySelector("form");
      this.input = this.querySelector("[name=q]");
      this.serializeForm = serializeForm;
      (_this$events = this.events) === null || _this$events === void 0 || _this$events.abort();
      const events = this.events = new AbortController();
      this.addEventListener("input", debounceTime(event => {
        if (!events.signal.aborted) this.onChange(event);
      }, 300).bind(this), {
        signal: events.signal
      });
      this.input.addEventListener("click", this.onFocus.bind(this), {
        signal: events.signal
      });
      this.input.addEventListener("focusin", this.onFocus.bind(this), {
        signal: events.signal
      });
      this.input.addEventListener("touchstart", this.onFocus.bind(this), {
        passive: true,
        signal: events.signal
      });
      this.addEventListener("focusout", this.onFocusOut.bind(this), {
        signal: events.signal
      });
      this.addEventListener("keyup", this.onKeyup.bind(this), {
        signal: events.signal
      });
      (_this$providerObserve = this.providerObserver) === null || _this$providerObserve === void 0 || _this$providerObserve.disconnect();
      this.providerObserver = new MutationObserver(() => this.suppressNativeSearch());
      this.providerObserver.observe(this.input, {
        attributes: true,
        attributeFilter: ["class"]
      });
      this.suppressNativeSearch();
    }
    disconnectedCallback() {
      var _this$events2, _this$providerObserve2;
      (_this$events2 = this.events) === null || _this$events2 === void 0 || _this$events2.abort();
      (_this$providerObserve2 = this.providerObserver) === null || _this$providerObserve2 === void 0 || _this$providerObserve2.disconnect();
      this.close();
    }
    cancelRequest() {
      var _this$requestControll;
      this.requestVersion = (this.requestVersion || 0) + 1;
      (_this$requestControll = this.requestController) === null || _this$requestControll === void 0 || _this$requestControll.abort();
      this.requestController = null;
    }
    suppressNativeSearch() {
      if (!this.input.classList.contains("esp-search-input")) return false;
      this.close();
      const results = this.querySelector(".js-search-result");
      const restoreInputFocus = results === null || results === void 0 ? void 0 : results.contains(document.activeElement);
      if (results !== null && results !== void 0 && results.childNodes.length) results.replaceChildren();
      if (restoreInputFocus) this.input.focus({
        preventScroll: true
      });
      return true;
    }
    onChange(e) {
      if (!this.isConnected || this.suppressNativeSearch()) return;
      const key = e.target.value.trim();
      if (!key.length) {
        this.close();
        return;
      }
      this.getRequest(key);
    }
    async getRequest(key, recommend) {
      if (!this.isConnected || this.suppressNativeSearch()) return;
      this.cancelRequest();
      const version = this.requestVersion;
      const controller = this.requestController = new AbortController();
      this.searchQuery = JSON.parse(this.serializeForm(this.form));
      this.searchQuery.q = key;
      this.searchQuery.section_id = this.dataset.section;
      this.classList.add("is-searching");
      const query = new URLSearchParams(this.searchQuery).toString();
      const url = this.dataset.url + "?" + query;
      try {
        const response = await fetch(url, {
          signal: controller.signal
        });
        if (!response.ok) throw new Error("Predictive search unavailable");
        const html = await response.text();
        if (version !== this.requestVersion || !this.isConnected || this.suppressNativeSearch()) return;
        const results = html.split("<!-- /// -->")[1];
        if (results === undefined) throw new Error("Predictive search results unavailable");
        this.querySelector(".js-search-result").innerHTML = results;
        this.open();
      } catch (error) {
        if (version === this.requestVersion) this.close();
      } finally {
        if (version === this.requestVersion) {
          this.classList.remove("is-searching");
          this.requestController = null;
        }
      }
    }
    focusSearch() {
      this.input.focus();
    }
    open() {
      if (this.suppressNativeSearch()) return;
      this.classList.add("show");
    }
    close() {
      this.cancelRequest();
      this.classList.remove("show", "is-searching");
    }
    onFocus() {
      this.open();
    }
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }
    onKeyup(event) {
      if (this.suppressNativeSearch()) return;
      if (event.code == "Escape") this.close();
    }
  };
  customElements.define("predictive-search", PredictiveSearch);
})();
